import SummarizeIcon from '@mui/icons-material/Summarize';
import { Avatar, Backdrop, Box, CircularProgress, Divider, Grid, IconButton, Typography } from "@mui/material";
import { decode } from "base-64";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KPeeLogo from '../LogoKPee1.png';
import { api } from '../api';
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from '../auth/Token';


const SingleCashPrint = () => {
    const location = useLocation();
    const one = location.state && location.state.one;
    const association_data = location.state && location.state.association_data;
    const association_id = location.state && location.state.association_id;
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [backdrop_open, setBackdrop_open] = useState(false)
    const [leaders, setLeaders] = useState([])
    // console.log(one)

    const fetchLeaders = () => {
        api.get(`/association/get/association/leaders/${association_id}`, {
          headers: {
              Authorization: 'Bearer '+fetchToken()
          },
        }).then(function (response){
          setLeaders(response.data)
        }).catch(function (error){
          console.log(error)
        });
    }

    function formatDateToYearMonthDay(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = 'th';
      
        if (day === 1 || day === 21 || day === 31) {
          suffix = 'st';
        } else if (day === 2 || day === 22) {
          suffix = 'nd';
        } else if (day === 3 || day === 23) {
          suffix = 'rd';
        }
      
        return `${day}${suffix} ${month} ${year}`;
      }

    useEffect(() => {
        fetchLeaders();
    },[])

    const handleBackdropClose = () => {
        setBackdrop_open(false);
    };
    const handleBackdropOpen = () => {
        setBackdrop_open(true);
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const pic = (pic) => {
        const de = decode(pic);
        return `data:image/jpeg;base64,${btoa(de)}`;
    };

const printRef = React.useRef();






const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    

    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginLeft = 10;
    const marginTop = 10;
    const marginRight = 10;
    const marginBottom = 10; 
    let yOffset = 0;
    let pageNumber = 1;

    while (yOffset < pdfHeight) {
        if (pageNumber > 1) {
            pdf.addPage();
        }

        pdf.addImage(
            data,
            'PNG',
            marginLeft,
            marginTop - yOffset,
            pdfWidth - marginLeft - marginRight,
            pdfHeight - marginTop - marginBottom
        );

        // Add page label
        pdf.setFontSize(8);  // Make the font size smaller
    pdf.text(`Page ${pageNumber}`, marginLeft - 9, pageHeight - marginBottom + 5);

        yOffset += pageHeight - marginTop - marginBottom;
        pageNumber++;
    }
  
    pdf.save('LoanContractAndDisbursementForm.pdf');
}
      
    
  return (
      <div className="app">
        <main className="content">
            <Box sx={{m:5}}>
                <Box sx={{ display:'flex', m:1 }}>
                    <Typography sx={{ ml:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Print:</b>
                        <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                    </Typography>
                </Box>
            <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                <Box sx={{ m:1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', color:'grey',mb:3 }}><b>~ The Cooperative ~</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Avatar src={KPeeLogo} alt='KPee logo' sx={{ width:120, height:120, m:'auto' }} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{one?.group_name}</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ display:'block', ml:5 }}>
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Society: {association_data?.Society}</b></Typography>
                            <Divider  variant='middle'/>
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cluster: {association_data?.Cluster}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Community: {association_data?.community_name}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Savings Group: {association_data?.Association_name}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Request Date: {formatDateToYearMonthDay(new Date(one?.Transaction_date))}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Member: {one?.Member_name}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Account: {one?.account_name}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Period: {one?.period}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Repayment start date: {one?.Repayment_starts}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Repayment end date: {one?.Repayment_ends}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Approved amount: {currencyFormat.format(one?.Recommended_amount?one?.Recommended_amount:one?.Amount)}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Interest amount: {currencyFormat.format(one?.interest_amount)}</b></Typography>
                            <Divider variant='middle' />
                            <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total amount to be repaid: {currencyFormat.format((one?.Recommended_amount?one?.Recommended_amount:one?.Amount) + one?.interest_amount)}</b></Typography>
                            <Divider variant='middle' />
                        </Grid>
                        
                        <Grid item xs={12} md={12}>
                            <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>Loan Disbursement Form</b></Typography>
                        </Grid>

                        
                        <Grid item xs={12} md={12}>
                            <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h4'><b>Group Guarantee</b></Typography>
                            <Typography textAlign='left' variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Although this agreement may be signed below by group leaders and Mr./Mrs./Miss {one?.Member_name}, it has been read and understood in His/Her respective language, and have agreed to its terms and conditions. The undersigned acknowledges that they are solely responsible and fully liable for repaying the full amount.</b>
                            </Typography>
                        </Grid>
                        
                        {
                            leaders.map((leader) => (
                                <Grid item xs={12} md={4}>
                                    <Divider sx={{ m:2, mt:5 }} />
                                    <Box>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{leader?.position} ({leader?.name})</b></Typography>
                                    </Box>
                                </Grid>
                            ))
                        }
                        <Grid item xs={12} md={4}>
                            <Divider sx={{ m:2, mt:5 }}/>
                            <Box>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{one?.Member_name}</b></Typography>
                            </Box>
                        </Grid>
                        {/* <Grid item xs={12} md={4} sx={{ mb:20, mt:5 }}>
                            <Divider />
                            <Box>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Sign</b></Typography>
                            </Box>
                        </Grid> */}
                    </Grid>

                </Box>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdrop_open}
                onClick={handleBackdropClose}
            >
                <CircularProgress color="secondary" />
            </Backdrop>
            </Box>
        </main>
            
      </div>
  )
}

export default SingleCashPrint